export default __webpack_public_path__ + "static/surrounded-231b58697e6c8eb8b2b83a87b3e213dc.svg";